import main from './main'

export class teras extends main{

   constructor (args) {
      super(args)
      this.name = 'sinp.biomedia.net.diventasocio'
      this.version = '1.0.1'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/diventasocio/' : ''
      this.page = {
         title: 'Home'
      }

      this.apiUrl = 'https://api.biomedia.net/201806/'
      this.mysql = {
         composer:'db',
         adapter:'bm',
         database:'bm_limmsy_sinp'
      }
   
      
      
      this._nazione=[]
      this._provincia=[]
      this._comune=[]
      this._regione=[]
      super.init()
      return this
   }

 
}
export default new teras
